import { mapRoutes } from './../../containers/map/map.routing'
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core'
import { FetchTemplateTagsRequest } from '@containers/templates/templates.actions'
import { getTemplateTagsState } from '@containers/templates/templates.selectors'
import { select, Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'template-tags',
  templateUrl: './template-tags.component.html',
  styleUrls: ['./template-tags.component.css'],
})
export class TemplateTagsComponent implements OnInit, OnDestroy {
  @Input() public open: boolean
  @Output() public onClose: EventEmitter<any> = new EventEmitter()

  public templates = []
  public tags = []
  public templatesTranslateKeys = []
  public templatesTranslateDefaults = []
  public tags$: Subscription

  constructor(
    private store: Store<any>,
    public translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.store.dispatch<any>(new FetchTemplateTagsRequest())

    this.tags$ = this.store
      .pipe(select(getTemplateTagsState))
      .subscribe((state) => {
        this.templates = state
          .get('data')
          .toJS()
          .filter((template) => {
            return template.tags.length
          })
        // .map((template) => {
        //   template.title = this.translateService.instant(
        //     template.type.translationKey,
        //     {
        //       defaultValue: template.type.title,
        //     },
        //   )
        //   return template
        // })

        this.templatesTranslateKeys = this.templates.map(
          ({ type: { translationKey } }) => translationKey,
        )

        this.templatesTranslateDefaults = this.templates.reduce(
          (prev, { type: { translationKey, title } }) => ({
            ...prev,
            [translationKey]: title,
          }),
          {},
        )
      })
  }

  ngOnDestroy(): void {
    this.tags$.unsubscribe()
  }

  public close() {
    this.onClose.emit()
  }

  public onTemplateChange(event) {
    this.tags = event?.tags ?? []
  }
}
